import { render, staticRenderFns } from "./Banat.vue?vue&type=template&id=10acbe9e&"
import script from "./Banat.vue?vue&type=script&lang=js&"
export * from "./Banat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports